import React, { useContext, useState }  from "react";
import { BsQuestionCircle } from "react-icons/bs";
import downalodImg from "../../../assest/images/download.svg";
import { DataContext } from "../../index";

export const AmountSection = () => {
  const counterState = useContext(DataContext);
  let {
    amountValue
  } = counterState;


  //  if(selectValue.section1 != null){
  //   setAmountValue(amountValue + selectValue.section1);
  //  }
  return (
    <div className="w-[650px]">
      <div className="col-md-3 p-0">
        <div className="tak-tours">
          <a href="javascript:;" className="themeBtn">
            Take A Quick Tour
          </a>
        </div>
        <div className="cal-step-count">
          <h3>OPTIONS</h3>
          <form>
            <div className="form-row flex gap-2 w-full justify-between items-center align-items-center ">
              <div className="col !text-xs">
                <label for="" className="!text-xs ">
                  Quantity <span>1 or 25 - 2,000</span>
                </label>
              </div>
              <div className="col w-40">
                <input type="number" className="form-control px-2 w-full" value="1" />
              </div>
            <div className="col">
              <p className="!text-xs">Nex price breaks at 25</p>
            </div>
            </div>
            <div className="form-row flex gap-2 justify-between items-center align-items-center mt-2 ">
              <div className="col w-full">
                <label for="" className="!text-xs">
                  Page Count <span>24 - 840</span>
                </label>
              </div>
              <div className="col">
                <input type="number" className="form-control" value="1" />
              </div>
            </div>

            <div className="form-row flex gap-2 justify-between items-center align-items-center mt-2">
              <div className="col w-full">
                <label for="" className="flex items-center gap-1 !text-xs">
                  Production Time{" "}
                  <BsQuestionCircle
                    fontSize={"18px"}
                    className="text-[#c65300]"
                  />
                </label>
              </div>
              <div className="col w-full">
                <div className="form-group">
                  <select
                    className="form-control !w-full"
                    id="exampleFormControlSelect1"
                  >
                    <option>Standard - 2 Days</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="cal-step-count noMargin">
          <h3>
            PROJECT TYPE{" "}
            <span>
              <a href="javascript:;">Get a new quote</a>
            </span>
          </h3>
          <p>Printed Books</p>

          <h3>
            GENRE{" "}
            <span>
              <a href="javascript:;">See all trim sizes</a>
            </span>
          </h3>
          <p>Sci-Fi, Fantasy, & Comic Books</p>
        </div>

        <div className="cal-step-count noMargin !border-b-0">
          <h3>
            QUOTE{" "}
            <span>
              <a href="javascript:;">View summary</a>
            </span>
          </h3>
          <form>
            <div className="form-row flex justify-between !my-4 align-items-center ">
              <div className="col">
                <label for="" className="label-icon">
                  Est. Ship Date{" "}
                  <span>
                    {/* <i className="fas fa-question"></i> */}
                    <BsQuestionCircle
                      fontSize={"18px"}
                      className="text-[#c65300]"
                    />
                  </span>
                </label>
              </div>
              <div className="col">
                <h5>Tuesday, Feb 27</h5>
              </div>
            </div>

            <div className="form-row align-items-center flex items-center gap-2">
              <div className="col-8">
                <input
                  type="text"
                  className="form-control border-[1px] border-solid border-[#000] px-1"
                  placeholder="Promo Code"
                />
              </div>
              <div className="col">
                <button type="submit" className="themeBtn">
                  Apply Code
                </button>
              </div>
            </div>
            <div className="form-row align-items-center flex justify-between">
              <div className="col">
                <label for="" className="label-icon">
                  Price
                  <br />{" "}
                  <span>
                    <BsQuestionCircle
                      fontSize={"18px"}
                      className="text-[#c65300]"
                    />
                  </span>
                </label>
                <label for="" className="label-icon">
                  <span className="py-2">(Excludes Tax & Shipping)</span>
                </label>
              </div>
              <div className="col">
                <h6>${amountValue}.00</h6>
              </div>
            </div>

            <div className="form-row align-items-center mt-4 ">
              <div className="col">
                <a href="javascript:;" className="payBtn text-center">
                  Pay in 4 interest-free payments of $24.75 with
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
